import { Injectable } from '@angular/core';
import { ControlBase } from "../form-controls/control-base";
import { TextboxControl, DropdownControl, DateControl } from "../form-controls/controls";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { of } from "rxjs";
import { map } from "rxjs/operators";
import axios from "axios";
import { DropdownOptions } from 'src/enums/dropdown-options';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { AuthService } from 'src/core/services/auth.service';
import { CompanyType } from 'src/interfaces/company';
import { DeliveryType } from 'src/interfaces/delivery-type';
import { IndividualType } from 'src/interfaces/individual';

@Injectable({
  providedIn: 'root'
})
export class ControlService {

  baseUrl: string = environment.api.baseUrl;
  headers: HttpHeaders;

  constructor(
    private _auth: AuthService,
    private http: HttpClient
  ) {
    this
      ._auth
      .generateRequestHeaders()
      .then((headers) => {
        this.headers = headers;
      })
  }

  toFormGroup(controls: ControlBase<string>[]) {
    const group: any = {};

    controls.forEach(control => {
      group[control.key] = control.required ? new FormControl(control.value || '', Validators.required)
        : new FormControl(control.value || '');
    });
    return new FormGroup(group);
  }

  // TODO: get from a remote source of question metadata
  getControls() {
    const controls: ControlBase<string>[] = [
      new TextboxControl({
        key: "title",
        label: "Title",
        type: "text",
        required: true,
        order: 1
      })
    ];
    return of(controls.sort((a, b) => a.order - b.order));
  }

  getDropdownOptions(options: DropdownOptions) {

    switch (options) {

      case DropdownOptions.CompanyTypes:
        return this
          .http
          .post<any>(`${this.baseUrl}/form-data`
            , ['company_type'],
            {
              headers: this.headers,
            }
          )
          .pipe(
            map((response: any) => {

              const companyTypes: CompanyType[] = response.data.company_type;

              const resultOptions: { key: string, value: string }[] = companyTypes
                .map((type: CompanyType) => ({
                  key: type.id.toString(), value: type.type
                }))

             return resultOptions;

            })
          );

      case DropdownOptions.DeliveryTypes:
        return this
          .http
          .post<any>(`${this.baseUrl}/form-data`
            , ['delivery_type'],
            {
              headers: this.headers,
            }
          )
          .pipe(
            map((response: any) => {

              const deliveryTypes = response.data.delivery_type;

              const resultOptions: { key: string, value: string }[] = deliveryTypes
                .map((type: DeliveryType) => ({
                  key: type.id.toString(), value: type.type
                }))

             return resultOptions;

            })
          );

      case DropdownOptions.IndividualTypes:
        return this
          .http
          .post<any>(`${this.baseUrl}/form-data`
            , ['individual_type'],
            {
              headers: this.headers,
            }
          )
          .pipe(
            map((response: any) => {

              const individualTypes = response.data.individual_type;

              const resultOptions: { key: string, value: string }[] = individualTypes
                .map((type: IndividualType) => ({
                  key: type.id.toString(), value: type.type
                }))

             return resultOptions;

            })
          );

      case DropdownOptions.Provinces:
        return this
          .http
          .get<any>("assets/provinces.json", {
            headers: this.headers
          });

      case DropdownOptions.Countries:
        return this
          .http
          .get<any>("assets/countries.json", {
            headers: this.headers
          });

      case DropdownOptions.Gender:
        return this
          .http
          .get<any>("assets/gender.json", {
            headers: this.headers
          });

      case DropdownOptions.Titles:
        return this
          .http
          .get<any>("assets/titles.json", {
            headers: this.headers
          });

      default:
        return null;

    }
  }

  createControls(metadata: any[]) {
    const controls: ControlBase<string>[] = [];
    let control = null;
    for (const controlMetaData of metadata) {
      switch (controlMetaData.controlType) {
        case 'textbox':
          control = new TextboxControl(controlMetaData);
          controls.push(control);
          break;
        case 'dropdown':
          control = new DropdownControl(controlMetaData);
          controls.push(control);
          break;
        case 'date':
          control = new DateControl(controlMetaData);
          controls.push(control);
          break;
      }
    }
    return of(controls.sort((a, b) => a.order - b.order))
  }

  async getControlMetaData(controlSetName: string): Promise<any[]> {
    try {
      const { data } = await axios.get(`/assets/${controlSetName}.json`);
      return data;
    } catch (error: any) {
      console.error(error);
      return [];
    }
  }


}
